import { defineStore } from 'pinia'
export const useSystemStore = defineStore('system', {
  state: () => ({
    currentLang: window?.localStorage?.getItem('currentLang') || 'en',
    currentTheme:
      window?.localStorage?.getItem('currentTheme') ||
      window.matchMedia('(prefers-color-scheme: dark)').matches
        ? 'dark'
        : 'light'
  }),
  getters: {
    getCurrentLang(state) {
      return state.currentLang
    },
    getCurrentTheme(state) {
      return state.currentTheme
    }
  },
  actions: {
    setCurrentLang(systemLang) {
      this.currentLang = systemLang
      window.localStorage.setItem('currentLang', this.currentLang)
    },
    setCurrentTheme(systemTheme) {
      this.currentTheme = systemTheme
      window.localStorage.setItem('currentTheme', systemTheme)
      document.querySelector(':root').setAttribute('data-theme', systemTheme)
    }
  }
})
